var map = {
	"./abstract01.webp": 2376,
	"./abstract010.webp": 2377,
	"./abstract02.webp": 2378,
	"./abstract03.webp": 2379,
	"./abstract05.webp": 2380,
	"./abstract06.webp": 2381,
	"./abstract07.webp": 2382,
	"./big_head_-1.webp": 2383,
	"./big_head_-10.webp": 2384,
	"./big_head_-2.webp": 2385,
	"./big_head_-3.webp": 2386,
	"./big_head_-5.webp": 2387,
	"./big_head_-6.webp": 2388,
	"./big_head_-7.webp": 2389,
	"./small_head_-1.webp": 2390,
	"./small_head_-10.webp": 2391,
	"./small_head_-2.webp": 2392,
	"./small_head_-3.webp": 2393,
	"./small_head_-5.webp": 2394,
	"./small_head_-6.webp": 2395,
	"./small_head_-7.webp": 2396,
	"./sponsor-banner-cn-m.webp": 2397,
	"./sponsor-banner-cn.webp": 2398,
	"./sponsor-banner-id-m.webp": 2399,
	"./sponsor-banner-id.webp": 2400,
	"./sponsor-banner-m.webp": 2401,
	"./sponsor-banner-ms-m.webp": 2402,
	"./sponsor-banner-ms.webp": 2403,
	"./sponsor-banner.webp": 2404,
	"./sponsor-bg-1-cn.webp": 2405,
	"./sponsor-bg-1-id.webp": 2406,
	"./sponsor-bg-1-ms.webp": 2407,
	"./sponsor-bg-1.webp": 2408,
	"./sponsor-bg-2-cn.webp": 2409,
	"./sponsor-bg-2-id.webp": 2410,
	"./sponsor-bg-2-ms.webp": 2411,
	"./sponsor-bg-2.webp": 2412,
	"./sponsor-bg-m-2-cn.webp": 2413,
	"./sponsor-bg-m-2-id.webp": 2414,
	"./sponsor-bg-m-2-ms.webp": 2415,
	"./sponsor-bg-m-2.webp": 2416,
	"./sponsor-video-one.mp4": 2417
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2375;